import React, { useState, useEffect, useMemo } from 'react';
import {
  Button,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  FormControlLabel,
  Checkbox,
  TextField,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useHistory, useParams } from 'react-router-dom';
import { css } from '@emotion/core';
import { Formik } from 'formik';
import { useRootStore } from '../../../../stores/BridgeProvider';
import {
  ButtonFlex,
  StyledForm,
  WideBox,
  FlexDiv,
} from '../../../styles/styles';
import Spinner from '../../../util/Spinner';
import SimpleSelect from '../../../util/SimpleSelect';

const UpdateField = ({
  json,
  updateTemplateJSON,
  handleClose,
  setSelectedField,
  selectedField,
}) => {
  const [fieldType, setFieldType] = useState(selectedField.type);

  const updateItem = values => {
    const filteredItems = json.items.filter(
      item => item.name !== selectedField.name,
    );

    let newItems = filteredItems;

    const { position, ...newItem } = values;
    if (position === 0) {
      newItems = [newItem, ...filteredItems];
    } else if (position) {
      newItems.splice(position, 0, newItem);
    } else {
      newItems = [...filteredItems, newItem];
    }

    updateTemplateJSON({ template: json.template, items: newItems });
  };

  const fieldTypeList = [
    { name: 'Text Input', type: 'string' },
    { name: 'Amount Input', type: 'dollar' },
    { name: 'Date Input', type: 'date' },
    { name: 'Contact Input', type: 'contact' },
    { name: 'Agent Input', type: 'agent' },
    { name: 'Custom Selector', type: 'enum' },
    { name: 'Transaction Category Selector', type: 'tranCategory' },
  ];

  return (
    <div>
      <div>
        <Typography variant="h4" gutterBottom>
          Update Template Field
        </Typography>

        <SimpleSelect
          label="Field Type"
          //   handleChange={handleChange}
          handleChange={e => setFieldType(e.target.value)}
          value={fieldType}
          name="type"
          containerStyle={{ width: '100%' }}
        >
          {fieldTypeList.map(({ type, name }) => (
            <MenuItem key={type} value={type}>
              {name}
            </MenuItem>
          ))}
        </SimpleSelect>
        {fieldType && (
          <Formik
            initialValues={selectedField}
            // validationSchema={DealTemplateSchema(items)}
            onSubmit={async (values, { resetForm, setSubmitting }) => {
              try {
                // setLoading(true);
                switch (fieldType) {
                  case 'string':
                    updateItem({
                      name: values.name,
                      type: 'string',
                      required: values.required,
                      displayName: values.displayName,
                      width: values.width,
                      position: values.position,
                    });
                    break;
                  case 'dollar':
                    updateItem({
                      name: values.name,
                      type: 'dollar',
                      required: values.required,
                      displayName: values.displayName,
                      width: values.width,
                      position: values.position,
                    });
                    break;
                  case 'contact':
                    updateItem({
                      name: values.name,
                      type: 'contact',
                      required: values.required,
                      displayName: values.displayName,
                      width: values.width,
                      position: values.position,
                    });
                    break;
                  case 'date':
                    updateItem({
                      name: values.name,
                      type: 'date',
                      required: values.required,
                      displayName: values.displayName,
                      width: values.width,
                      position: values.position,
                    });
                    break;
                  case 'agent':
                    updateItem({
                      name: values.name,
                      type: 'agent',
                      required: values.required,
                      displayName: values.displayName,
                      width: values.width,
                      position: values.position,
                    });
                    break;
                  case 'enum':
                    updateItem({
                      name: values.name,
                      type: 'enum',
                      required: values.required,
                      displayName: values.displayName,
                      width: values.width,
                      position: values.position,
                      // TODO: DYNAMIC
                      enumOptions: ['Draft', 'Submitted', 'Approved'],
                    });
                    break;
                  case 'dealStatus':
                    addNewItem({
                      name: values.name,
                      type: 'enum',
                      required: values.required,
                      displayName: values.displayName,
                      width: values.width,
                      enumOptions: ['Draft', 'Submitted', 'Approved'],
                    });
                    break;
                  case 'tranCategory':
                    updateItem({
                      name: values.name,
                      type: 'tranCategory',
                      required: values.required,
                      displayName: values.displayName,
                      width: values.width,
                      position: values.position,
                    });
                    break;
                  default:
                    break;
                }
                setFieldType(null);
                handleClose();
                resetForm();
                setSelectedField({});
              } catch (e) {
                console.error(e);
              }
              setSubmitting(false);
              // setLoading(false);
            }}
            render={formikProps => {
              const {
                handleSubmit,
                isSubmitting,
                isValid,
                dirty,
                handleChange,
                handleBlur,
                setFieldValue,
                values,
                resetForm,
              } = formikProps;
              const deleteItem = () => {
                const filteredItems = json.items.filter(
                  item => item.name !== selectedField.name,
                );
                updateTemplateJSON({
                  template: json.template,
                  items: filteredItems,
                });
                resetForm();

                handleClose();
                setSelectedField({});
              };
              const generateFormFields = () => {
                if (
                  [
                    'string',
                    'dollar',
                    'date',
                    'contact',
                    'agent',
                    'tranCategory',
                    'enum',
                    'dealStatus',
                  ].includes(fieldType)
                ) {
                  return (
                    <div>
                      <TextField
                        name="name"
                        label="Variable Name"
                        value={values.name}
                        margin="normal"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="outlined"
                        fullWidth
                      />
                      <TextField
                        name="displayName"
                        label="Input Name"
                        value={values.displayName}
                        margin="normal"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="outlined"
                        fullWidth
                      />
                      <SimpleSelect
                        label="Input Width"
                        handleChange={handleChange}
                        value={values.width}
                        name="width"
                        containerStyle={{ width: '100%' }}
                      >
                        <MenuItem value={100}>Full Width</MenuItem>
                        <MenuItem value={50}>Half Width</MenuItem>
                      </SimpleSelect>
                      <SimpleSelect
                        label="Position in Template"
                        handleChange={handleChange}
                        value={values.position}
                        name="position"
                        containerStyle={{ width: '100%' }}
                      >
                        {new Array(json.items.length).fill(null).map((x, i) => (
                          <MenuItem value={i}>{i + 1}</MenuItem>
                        ))}
                      </SimpleSelect>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!values.required}
                            onChange={(e, val) => {
                              setFieldValue('required', val);
                            }}
                            value={values.required}
                          />
                        }
                        label="Is Required"
                      />
                    </div>
                  );
                }

                return null;
              };
              return (
                <StyledForm onSubmit={handleSubmit}>
                  {generateFormFields()}
                  <ButtonFlex>
                    <Button
                      color="primary"
                      variant="contained"
                      type="submit"
                      size="large"
                      disabled={!dirty || isSubmitting}
                      style={{
                        margin: '5px',
                      }}
                    >
                      Update Field
                    </Button>
                    <Button
                      color="secondary"
                      variant="contained"
                      type="submit"
                      size="large"
                      disabled={isSubmitting}
                      onClick={deleteItem}
                    >
                      Delete Field
                    </Button>
                  </ButtonFlex>
                </StyledForm>
              );
            }}
          />
        )}
      </div>
    </div>
  );
};

export default UpdateField;
